import { useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import SEO from '../components/SEO'
import { projectData, tagColors } from '../data/portfolioData'
import { CiMobile4 } from 'react-icons/ci'
import { FaLaptopCode } from 'react-icons/fa'
import { MdDesignServices } from 'react-icons/md'

const categories = [
  { id: 'web-app', label: 'Web Application', icon: FaLaptopCode, dataKey: 'web' },
  { id: 'mobile-app', label: 'Mobile Application', icon: CiMobile4, dataKey: 'app' },
  { id: 'admin-panel', label: 'Admin Panel', icon: FaLaptopCode, dataKey: 'web' },
  { id: 'ui-ux', label: 'UI/UX Designing', icon: MdDesignServices, dataKey: 'blockchain' },
]

const Portfolio = () => {
  const navigate = useNavigate()
  const [selectedCategoryId, setSelectedCategoryId] = useState('mobile-app')

  const selectedCategory = useMemo(
    () => categories.find((item) => item.id === selectedCategoryId) || categories[0],
    [selectedCategoryId]
  )

  const projects = (projectData && projectData[selectedCategory.dataKey]) || []

  return (
    <div>
      <SEO title="Our Work" description="Check out MindVista's portfolio of successful web and mobile projects." />
      <section className="py-16">
        <div className="container-main">
          <div className="neo-card p-7 md:p-10">
            <span className="section-kicker">Our Work</span>
            <h1 className="mt-4 text-4xl font-bold md:text-6xl">Portfolio</h1>
            <p className="mt-3 text-lg text-[#adadad]">Creative work & case studies</p>

            <div className="mt-7 flex flex-wrap gap-2">
              {categories.map((category) => {
                const Icon = category.icon
                const active = category.id === selectedCategoryId
                return (
                  <button
                    key={category.id}
                    type="button"
                    onClick={() => setSelectedCategoryId(category.id)}
                    className={`inline-flex items-center gap-2 rounded-full border px-4 py-2 text-sm font-semibold ${
                      active
                        ? 'border-[rgb(249,193,37)] bg-[rgb(249,193,37)] text-black'
                        : 'border-white/15 bg-[#171717] text-white/85 hover:border-[rgb(249,193,37)]/50 hover:text-[rgb(249,193,37)]'
                    }`}
                  >
                    <Icon className="h-4 w-4" />
                    {category.label}
                  </button>
                )
              })}
            </div>
          </div>
        </div>
      </section>

      <section className="pb-20">
        <div className="container-main space-y-5">
          {projects.length > 0 ? (
            <>
              <button
                type="button"
                onClick={() => navigate(`/project/${selectedCategory.dataKey}/0`)}
                className="group relative block w-full overflow-hidden rounded-3xl border border-white/10 text-left"
              >
                <img
                  src={projects[0].image[0]}
                  alt={projects[0].title}
                  className="h-[420px] w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  onError={(e) => {
                    e.currentTarget.src = `https://via.placeholder.com/1200x600/1f1f1f/c8e64a?text=${encodeURIComponent(projects[0].title)}`
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/35 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                  <h2 className="text-3xl font-semibold text-white md:text-5xl">{projects[0].title}</h2>
                  <p className="mt-3 max-w-3xl text-sm text-[#cbcbcb] md:text-base">{projects[0].description}</p>
                </div>
              </button>

              <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
                {projects.slice(1).map((project, idx) => (
                  <button
                    type="button"
                    key={project.title + idx}
                    onClick={() => navigate(`/project/${selectedCategory.dataKey}/${idx + 1}`)}
                    className="neo-card neo-card-hover overflow-hidden text-left"
                  >
                    <img
                      src={project.image[0]}
                      alt={project.title}
                      className="h-52 w-full object-cover"
                      onError={(e) => {
                        e.currentTarget.src = `https://via.placeholder.com/700x420/1f1f1f/c8e64a?text=${encodeURIComponent(project.title)}`
                      }}
                    />
                    <div className="p-5">
                      <h3 className="text-2xl font-semibold text-white">{project.title}</h3>
                      <p className="mt-2 line-clamp-3 text-sm text-[#aaaaaa]">{project.description}</p>
                      <div className="mt-4 flex flex-wrap gap-2">
                        {project.tags.slice(0, 4).map((tag, tagIdx) => (
                          <span
                            key={`${tag}-${tagIdx}`}
                            className={`rounded-full px-2.5 py-1 text-[11px] font-semibold ${tagColors[tag] || 'bg-[#2a2a2a] text-[#dadada]'}`}
                          >
                            {tag}
                          </span>
                        ))}
                      </div>
                    </div>
                  </button>
                ))}
              </div>
            </>
          ) : (
            <div className="neo-card p-10 text-center">
              <p className="text-2xl font-semibold text-white">No projects available for this category</p>
              <p className="mt-2 text-[#9e9e9e]">Please try another category filter.</p>
            </div>
          )}
        </div>
      </section>
    </div>
  )
}

export default Portfolio


